import React, { Fragment } from 'react';
import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router-dom';
import core, { App, Poller, Viewport } from '@gin-betting/core';

import { MobileTopMenu } from 'views/top-menu';
import matchList from 'modules/match-list';
import promo from 'modules/promo';
import ui from 'modules/ui';

import { MatchListType } from 'app-constants';

const {
    poller: { withPolling },
    entities: {
        selectors: { selectSportTypeFromLocation },
    },
    viewport: {
        selectors: { makeViewportSelector },
    },
    utils: { getBettingOptions },
} = core;
const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    pagination: {
        selectors: { selectIsPollingTurnedOff },
    },
    components: { MatchListContainer },
} = matchList;
const {
    components: { TopMatchList, MobileTopMatchList },
} = promo;
const {
    selectors: { selectIsMobileTopMatchesOpened },
} = ui;

const selectLessThanOrEqual = makeViewportSelector('lessThanOrEqual');

const selectIsMobileTopMatchesOpenedByPlatform = createSelector(
    selectIsMobileTopMatchesOpened,
    selectLessThanOrEqual,
    (
        isMobileTopMatchesOpened: boolean,
        lessThanOrEqual: Viewport.Breakpoints
    ): boolean => {
        const isBettingPage = getBettingOptions().url.pagePath === '';

        return (
            isMobileTopMatchesOpened && isBettingPage && lessThanOrEqual.medium
        );
    }
);

const selectIsPollingTurnedOffByPlatform = createSelector(
    selectIsMobileTopMatchesOpenedByPlatform,
    selectIsPollingTurnedOff,
    (isMobileTopMatchesOpened, isPollingTurnedOff) =>
        !isMobileTopMatchesOpened && isPollingTurnedOff
);

interface OwnProps extends RouteComponentProps<any> {}

interface MappedProps {
    isPollingTurnedOff: boolean;
    shouldRenderMobileTopMatches: boolean;
    fetchStatus: App.FetchStatus;
    sportType: ReturnType<typeof selectSportTypeFromLocation>;
}

interface MappedActions {
    lessThanOrEqual: Viewport.Breakpoints;
}

type Props = OwnProps &
    MappedActions &
    MappedProps & {
        poller: Poller.Poller<typeof searchMatches>;
    };

class Upcoming extends React.Component<Props> {
    render() {
        const {
            fetchStatus,
            poller,
            lessThanOrEqual,
            sportType,
            shouldRenderMobileTopMatches,
        } = this.props;

        const isBettingPage = getBettingOptions().url.pagePath === '';
        const shouldRenderTopMatches = isBettingPage && !lessThanOrEqual.medium;

        return (
            <Fragment>
                {shouldRenderTopMatches && (
                    <TopMatchList sportType={sportType} />
                )}

                {shouldRenderMobileTopMatches ? (
                    <Fragment>
                        <MobileTopMenu fetchStatus={fetchStatus} />
                        <MobileTopMatchList />
                    </Fragment>
                ) : (
                    <MatchListContainer
                        type={MatchListType.UPCOMING}
                        fetchStatus={fetchStatus}
                        poller={poller}
                    />
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isPollingTurnedOff: selectIsPollingTurnedOffByPlatform,
    shouldRenderMobileTopMatches: selectIsMobileTopMatchesOpenedByPlatform,
    fetchStatus: selectFetchStatus,
    lessThanOrEqual: makeViewportSelector('lessThanOrEqual'),
    sportType: selectSportTypeFromLocation,
});

export default compose(
    connect<MappedProps, MappedActions, OwnProps>(mapStateToProps),
    withPolling({
        pollerName: App.PollerName.Upcoming,
        executableAction: searchMatches,
    })
)(Upcoming);
